import { createContext, FC, lazy, ReactNode, Suspense, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Menu, MenuProps, Popover } from 'antd';
import { FlexEnum, ModeEnum } from '@hylaa-npm/ipod';

import System from '@/container/System';
// import { Commpoents } from '@/container/Tag';
import { StaffPage } from '@/container/Staff';
import { ProjectFns, ProjectList } from '@/container/Project';
import { IOverview } from '@/container/Project/components/ProjectFn';

import Member from '@/container/Member';

import { IRouter, userProjectRoutes } from '@/routers';
import * as router from '@/routers/routePathKey';
import { PageTypeEnum } from '@/utils/enum';
import { getStorage } from '@/utils/storage';
import types from '@/redux/type';
import { renewToken } from '@/apis/login';
import { logout } from '@/utils/logout';
import accountIcon from '@/images/navs/account.svg';
import logInOutIcon from '@/images/navs/loginout.svg';

import { CenterWrap, UserContentWrap, UserProjectWrap } from './style';
import { BASEURL } from '@/apis';
import { IPOAvatar } from '@hylaa-npm/ipod';
import store from '@/redux/store';
import { clientList } from '@/apis/printer';
import { IFavorApi } from '@/apis/profileFavor';

const MemberDetail = lazy(() => import('@/container/Member/components/Detail'));

const DataOnline = lazy(() => import('@/container/DataOnline'));

const Printer = lazy(() => import('@/container/Printer'));
const PrinterDetail = lazy(() => import('@/container/Printer/components/Detail'));

const PhoneMsg = lazy(() => import('@/container/MsgHistory/PhoneMsg'));
const WhatsappMsg = lazy(() => import('@/container/MsgHistory/WhatsappMsg'));
const WXMsg = lazy(() => import('@/container/MsgHistory/WXMsg/index'));
const LineMsg = lazy(() => import('@/container/MsgHistory/LineMsg'));
const MessagePage = lazy(() => import('@/container/MessageHisPage'));

const AsyncHistory = lazy(() => import('@/container/AsyncHistory/components/CenterAsync'));
const AsyncClientHistory = lazy(() => import('@/container/AsyncHistory/components/ClientAsync'));

const AppVersion = lazy(() => import('@/container/AppVersion'));

const MemberPage = lazy(() => import('@/container/Home'));
const UserInfoPage = lazy(() => import('@/container/UserPage'));
const TagPage = lazy(() => import('@/container/Tag'));

const Userpage = lazy(() => import('@/container/User'));
// const UI = lazy(() => import('@/container/UI'));

export const FavorContext = createContext<[IFavorApi, (fav: IFavorApi) => void]>([
	{
		layoutCode: FlexEnum.TOP,
		patternCode: ModeEnum.SIMPLE,
	},
	() => {},
]);

const Index: FC<{}> = () => {
	const { i18n } = useTranslation();
	const dispatch = useDispatch();
	const history = useHistory();
	const location = useLocation();
	const rootSubmenuKeys: string | string[] = userProjectRoutes.map((item) => item.path);
	const currentPageType = useSelector(
		(state: { currentPageType: PageTypeEnum }) => state.currentPageType,
	);
	const loginStatus = useSelector((state: { loginStatus: boolean }) => state.loginStatus); //登录状态
	const userInfo = useSelector((state: { userInfo: IUserInfo }) => state.userInfo);
	const [pageType, setPageType] = useState<PageTypeEnum>(PageTypeEnum.SYSTEM_PAGE); //要显示的页面类型
	const [currentProjectInfo, setCurrentProjectInfo] = useState<IOverview>();
	const [selectedKeys, setSelectedKeys] = useState<string[]>(); //选中的路由
	const [openKeys, setOpenKeys] = useState<string[]>([]);

	const ALLTIME: number = 20 * 60 * 1000; // 20 分钟
	let timer: NodeJS.Timeout | null = null;
	useEffect(() => {
		if (loginStatus) {
			getNewToken();
		} else {
			if (location.pathname === router.KEY_PATH_USERINFOPAGE) {
				setPageType(PageTypeEnum.MEMBERINFO);
				// 改变·页面类型
				store.dispatch({
					type: types.CHANGE_CURRENT_PAGE_TYPE,
					data: PageTypeEnum.MEMBERINFO,
				});
			}
		}
		window.eventEmitter.on('projectInfo', (curProjectInfo: IOverview) =>
			setCurrentProjectInfo(curProjectInfo),
		);
	}, []);
	useEffect(() => {
		if (pageType === PageTypeEnum.MANEGE_PAGE) {
			getClientList();
		}
	}, [pageType]);

	useEffect(() => {
		if (loginStatus) {
			// 刷新token
			globalTimer();
			if (location) {
				userProjectRoutes.forEach((item) => {
					if (item.children) {
						item.children.forEach((v) => {
							if (v.path === location.pathname) {
								setSelectedKeys([v.path]);
								setOpenKeys([item.path]);
							}
						});
					}
					if (location.pathname === item.path) {
						setSelectedKeys([item.path]);
						setOpenKeys([item.path]);
					}
				});
			} else {
				setSelectedKeys([router.KEY_PATH_PROJECT]);
			}
		} else {
			if (location.pathname === router.KEY_PATH_USERINFOPAGE) {
				setPageType(PageTypeEnum.MEMBERINFO);
				store.dispatch({
					type: types.CHANGE_CURRENT_PAGE_TYPE,
					data: PageTypeEnum.MEMBERINFO,
				});
				// 改变·页面类型
			}
		}
		return () => clearInterval(timer as NodeJS.Timeout);
	}, [loginStatus]); //定时刷新与token
	useEffect(() => {
		setPageType(currentPageType);
	}, [currentPageType]); //改变页面类型 成员、员工、登录
	const globalTimer: () => void = () => {
		timer = setInterval(() => {
			getNewToken();
		}, ALLTIME);
	};

	const getNewToken: () => void = async () => {
		try {
			if (!getStorage('refreshToken')) {
				dispatch({
					type: types.CHANGE_LOGIN_STATUS,
					data: false,
				});
				return;
			}
			let refresh: string = getStorage('refreshToken');
			renewToken(refresh);
		} catch (e) {}
	};
	// 路由的跳转
	const handleRouter = (key: string) => {
		setSelectedKeys([key]);
	};
	// 获取分端列表
	const getClientList = () => {
		// if (pageType === PageTypeEnum.MANEGE_PAGE) {
		clientList().then((res: unknown) => {
			const list: ISplitEnd[] = (res as { list: ISplitEnd[] }).list;
			dispatch({
				type: types.CHANGE_CLIENTS,
				data: list,
			});
		});
		// }
	};
	const getLeftText = (key: string, name?: string) => {
		if (key === 'project') {
			return i18n.t('project.project');
		} else if (key === 'tag') {
			return i18n.t('tag.title');
		} else if (key === 'standard') {
			return i18n.t('standard.title');
		} else if (key === 'tag-team') {
			return i18n.t('tag.teamLabel');
		} else if (key === 'tag-major') {
			return i18n.t('tag.professionalLabel');
		} else if (key === 'data') {
			return i18n.t('data-online.dataMonitoring');
		} else if (key === 'printer') {
			return i18n.t('printer.accessThePrinter');
		} else if (key === 'history') {
			return i18n.t('msg-history.messageRecord');
		} else if (key === 'short') {
			return i18n.t('msg-history.shortMessage');
		} else if (key === 'WeChat') {
			return i18n.t('msg-history.WeChat');
		} else if (key === 'WHATSAPP') {
			return name;
		} else if (key === 'LINE') {
			return name;
		} else if (key === 'staff-admin') {
			return i18n.t('staff.staffAdmin');
		} else if (key === 'staff') {
			return i18n.t('staff.staff');
		} else if (key === 'staffDisabled') {
			return i18n.t('staff.staffDisabled');
		} else if (key === 'async') {
			return '同步记录';
		} else if (key === 'async-center') {
			return '中心向分端同步';
		} else if (key === 'async-client') {
			return '分端向中心同步';
		} else if (key === 'app') {
			return 'APP发布记录';
		}
	};
	// 后台
	const getUserProjectEle: () => ReactNode = () => {
		const onOpenChange: MenuProps['onOpenChange'] = (keys) => {
			const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
			if (rootSubmenuKeys.indexOf(latestOpenKey!) === -1) {
				setOpenKeys(keys);
			} else {
				setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
			}
		};
		const getIsSelect: (key: string, list?: IRouter[]) => boolean = (key, list = []) => {
			if (selectedKeys) {
				if (selectedKeys[0] === key) {
					return true;
				}
				for (let i = 0; i < list.length; i++) {
					if (selectedKeys[0] === list[i].path) {
						return true;
					}
				}
			}
			return false;
		};
		const systemOut = () => {
			setSelectedKeys([router.KEY_PATH_PROJECT]);
			history.replace('/');
			logout();
		};
		const UserContent = () => {
			return (
				<UserContentWrap>
					<div
						className={
							selectedKeys && selectedKeys[0] === router.KEY_PATH_USER
								? 'account-wrap select'
								: 'account-wrap'
						}
						onClick={() => {
							setSelectedKeys([router.KEY_PATH_USER]);
							history.replace(router.KEY_PATH_USER);
						}}>
						<img src={accountIcon} alt="" /> 账号资料设置
					</div>
					<div className="line"></div>
					<div className="login-wrap" onClick={systemOut}>
						<img src={logInOutIcon} alt="" /> {i18n.t('common.signOut')}
					</div>
				</UserContentWrap>
			);
		};
		return (
			<UserProjectWrap>
				<div className="left-menu--wrap">
					<div className="top--wrap">
						<div className="project-title--wrap">
							<i className="icon-ico"></i>
							<h1>{i18n.t('common.centerSer')}</h1>
						</div>
						<div className="navs--wrap">
							{userProjectRoutes.map((nav) => {
								if (!nav.letNav) return;
								// 判断类型
								if (!nav.role.includes(userInfo.role)) return;
								return (
									<Menu
										onOpenChange={onOpenChange}
										openKeys={openKeys}
										theme={'dark'}
										onClick={(e) => handleRouter(e.key)}
										triggerSubMenuAction={'click'}
										selectedKeys={selectedKeys}
										mode="inline"
										key={nav.path}>
										{nav.children && nav.children.length > 0 ? (
											<Menu.SubMenu
												title={getLeftText(nav.key, nav.name)}
												key={nav.path}
												icon={
													<img
														style={{ opacity: getIsSelect(nav.path, nav.children) ? '1' : '0.69' }}
														src={nav.navIcon}
													/>
												}>
												{nav.children?.map((item) => {
													return (
														<Menu.Item key={item.path} title={getLeftText(item.key, item.name)}>
															<NavLink to={item.path} key={item.path}>
																{getLeftText(item.key, item.name)}
															</NavLink>
														</Menu.Item>
													);
												})}
											</Menu.SubMenu>
										) : (
											<Menu.Item key={nav.path} title={getLeftText(nav.key, nav.name)}>
												<NavLink to={nav.path} key={nav.path}>
													<img
														src={nav.navIcon}
														style={{
															opacity:
																(selectedKeys && selectedKeys[0]) === nav.path ? '1' : '0.69',
														}}
													/>
													<span>{getLeftText(nav.key, nav.name)}</span>
												</NavLink>
											</Menu.Item>
										)}
									</Menu>
								);
							})}
						</div>
					</div>
					<div className="bottom-btns-wrap">
						<Popover placement="right" content={UserContent()} trigger="click">
							<div
								className={
									selectedKeys && selectedKeys[0] === router.KEY_PATH_USER
										? 'user-wrap user-wrap-select'
										: 'user-wrap'
								}>
								<IPOAvatar
									size={26}
									info={{
										avatar: userInfo.avatar,
										name: userInfo.name1,
										id: userInfo.id,
										name2: userInfo.name2,
										mobile: userInfo.mobile,
										baseUrl: BASEURL,
									}}
								/>
								{userInfo.name2 || userInfo.name1 || userInfo.mobile}
							</div>
						</Popover>
					</div>
				</div>
				<div className="right--wrap">
					<Suspense fallback={<div>Loading...</div>}>
						<Switch>
							<Route exact path={router.KEY_PATH_STANDARD_LIBRARY} component={Member} />
							<Route
								exact
								path={router.KEY_PATH_STANDARD_LIBRARY_DETAIL}
								component={MemberDetail}
							/>
							<Route exact path={router.KEY_PATH_LABEL.KEY_PATH_TEAM} component={TagPage} />
							<Route exact path={router.KEY_PATH_LABEL.KEY_PATH_MAJOR} component={TagPage} />
							<Route exact path={router.KEY_PATH_ONLINE} component={DataOnline} />
							<Route
								exact
								path={router.KEY_PATH_MESSAGE.KEY_PATH_MESSAGE_PHONE}
								component={PhoneMsg}
							/>
							<Route exact path={router.KEY_PATH_MESSAGE.KEY_PATH_MESSAGE_WX} component={WXMsg} />
							<Route
								exact
								path={router.KEY_PATH_MESSAGE.KEY_PATH_MESSAGE_LINE}
								component={LineMsg}
							/>
							<Route
								exact
								path={router.KEY_PATH_MESSAGE.KEY_PATH_MESSAGE_WHATSAPP}
								component={WhatsappMsg}
							/>
							<Route exact path={router.KEY_PATH_PRINTER} component={Printer} />
							<Route exact path={router.KEY_PATH_PRINTER_DETAIL} component={PrinterDetail} />
							<Route exact path={router.KEY_PATH_PROJECT} component={ProjectList} />
							<Route
								exact
								path={router.KEY_PATH_STAFF.KEY_PATH_ENABLED_STAFF}
								component={StaffPage.StaffEnabled}
							/>
							<Route
								exact
								path={router.KEY_PATH_STAFF.KEY_PATH_DISABLED_STAFF}
								component={StaffPage.StaffDisabled}
							/>
							<Route exact path={router.KEY_PATH_USER} component={Userpage} />
							<Route
								exact
								path={router.KEY_PATH_ASYNC.KEY_PATH_ASYNC_CENTER}
								component={AsyncHistory}
							/>
							<Route
								exact
								path={router.KEY_PATH_ASYNC.KEY_PATH_ASYNC_CLIENT}
								component={AsyncClientHistory}
							/>
							<Route exact path={router.KEY_PATH_APPVERSION} component={AppVersion} />
							<Route exact path="/">
								{/* 如果没有登录呢 */}
								{loginStatus && <Redirect to={router.KEY_PATH_PROJECT} />}
								{!loginStatus && <System />}
							</Route>
							{/* 设置一个没有匹配的路由 */}
							<Route path="*">
								{loginStatus && <Redirect to={router.KEY_PATH_PROJECT} />}
								{!loginStatus && <System />}
							</Route>
							{/* <Route exact path={router.KEY_PATH_UI} component={UI} /> */}
						</Switch>
					</Suspense>
				</div>
			</UserProjectWrap>
		);
	};
	// 成员
	const getMemberEle = () => {
		return (
			<Suspense fallback={<div>Loading...</div>}>
				<Switch>
					<Route exact path={router.KEY_PATH_USERINFOPAGE} component={UserInfoPage} />
					<Route exact path={router.KEY_PATH_MEMBERPAGE} component={MemberPage} />
					<Route exact path={router.KEY_PATH_MESSAGEPAGE} component={MessagePage} />
					<Route exact path="/">
						<Redirect to={router.KEY_PATH_MEMBERPAGE} />
					</Route>
					<Route component={MemberPage} />
				</Switch>
			</Suspense>
		);
	};
	return (
		<CenterWrap>
			{pageType === PageTypeEnum.SYSTEM_PAGE && <System />}
			{pageType === PageTypeEnum.MANEGE_PAGE && loginStatus && getUserProjectEle()}
			{pageType === PageTypeEnum.USER_PAGE && loginStatus && getMemberEle()}
			{currentProjectInfo && (
				<ProjectFns.OverviewModal
					{...currentProjectInfo}
					handleClose={() => setCurrentProjectInfo(undefined)}
				/>
			)}
			{!loginStatus && (
				<Suspense fallback={<div>Loading...</div>}>
					<Switch>
						<Route exact path={router.KEY_PATH_USERINFOPAGE} component={UserInfoPage} />
					</Switch>
				</Suspense>
			)}
		</CenterWrap>
	);
};
export default Index;
